export class ServiceError {
    errorCode: number;
    errorMessage: string;
}
